import React from 'react';
import ResultsWrapper from './ResultsWrapper';

const NoResults = () => <ResultsWrapper>No results found for your selected filters.</ResultsWrapper>;

export default NoResults;
